const stepper = ["事前確認", "提出内容確認", "掛金の確認", "機構へ提出"];

const InfoManual = `掛金納付対象職員届の提出の前に次の手続きが終わっていることが必要となります。<
それぞれ確認をしてください。`;

const itemList = [
  {
    number: 0,
    type: "lineTitle",
    lineTitle: (
      <>
        １.登録されている施設の確認（共済契約者が経営する施設のうち、共済契約対象施設の確認）
        <br />　 登録されている施設の状況について確認をしてください。
      </>
    ),
  },
  {
    number: 1,
    type: "item",
    title:
      "確認１.４月１日までに新設した施設・事業はすべて登録されていますか？",
    funcButton: "施設・事業を新たに登録する",
    confirmNavi: "/SCRC050030",
    funcNavi: "/SCRC050101",
    businessType: "JOB-15",
    helpIcon: true,
    helpText: (
      <>
        「社会福祉施設等」については、経営する施設・事業をすべて登録してください。「特定介護保険施設等」「申出施設等」については、契約対象として申出する施設・事業のみ登録してください。施設区分は
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫施設区分について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        を参照してください。
      </>
    ),
    guideText: "施設の登録を行ってください。",
  },
  {
    number: 2,
    type: "item",
    title:
      "確認２.３月３１日までに廃止・休止した施設・事業の手続きは終わっていますか？",
    funcButton: "廃止・休止の手続きをする",
    confirmNavi: "/SCRC050030",
    funcNavi: "/SCRC050120",
    businessType: "JOB-18",
    guideText: "廃止・休止の手続きを行ってください。",
  },
  {
    number: 3,
    type: "item",
    title: "確認３.各施設の名称、所在地、施設種類の登録情報は正しいですか？",
    funcButton: "名称・所在地・施設種類の変更をする",
    confirmNavi: "/SCRC050030",
    funcNavi: "/SCRC050017",
    businessType: "JOB-17",
    guideText: "名称・所在地・施設種類の修正を行ってください。",
  },
  {
    number: 4,
    type: "item",
    title: "確認４.特定職員数又は措置入所障害児職員数は正しいですか？",
    funcButton: "特定職員数又は措置入所障害児職員数を修正する",
    confirmNavi: "/SCRC050030",
    funcNavi: "/SCRC050029",
    businessType: "JOB-20",
    guideText: "特定職員数又は措置入所障害児職員数の修正を行ってください。",
  },
  {
    number: 0,
    type: "lineTitle",
    lineTitle: (
      <>
        ２.登録されている職員の確認
        <br />　 登録されている職員一覧の状況について確認をしてください。
      </>
    ),
  },
  {
    number: 5,
    type: "item",
    title:
      "確認５.４月１日までに採用した加入要件のある職員はすべて登録されていますか？",
    funcButton: "職員の登録をする",
    confirmNavi: "/SCRC060033",
    funcNavi: "/SCRC060108",
    businessType: "JOB-23",
    helpIcon: true,
    helpText: (
      <>
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫加入要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          加入要件
        </a>
        を満たす職員はパート職員、嘱託職員等においてもすべて登録が必要です。
      </>
    ),
    guideText: "職員の登録を行ってください。",
  },
  {
    number: 6,
    type: "item",
    title: "確認６.４月１日現在の職員の配置換え手続きは終わっていますか？",
    funcButton: "配置換え手続きをする",
    confirmNavi: "/SCRC060033",
    funcNavi: "/SCRC060103",
    businessType: "JOB-27",
    guideText: "配置換え手続きを行ってください。",
  },
  {
    number: 7,
    type: "item",
    title: "確認７.４月１日現在の俸給額に更新されていますか？",
    funcButton: "俸給の更新をする",
    confirmNavi: "/SCRC060033",
    funcNavi: "/SCRC060116",
    businessType: "JOB-26",
    guideText: "俸給の更新を行ってください。",
  },
  {
    number: 8,
    type: "item",
    title:
      "確認８.３月３１日までの全被共済職員の従業状況はすべて更新されていますか？３月３１までに退職した職員の退職日は登録されていますか？",
    funcButton: "従業状況を更新する",
    confirmNavi: "/SCRC060033",
    funcNavi: "/SCRC060112",
    businessType: "JOB-10",
    helpIcon: true,
    helpText: (
      <>
        「共済制度上の退職」については
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫本制度の「退職」について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
        <br />
        なお、当制度においては、引き続き勤務されるようなケースにおいても主に次のようなケースは「退職」の扱いとなります。
        <br />
        ①加入要件を満たさない雇用条件に変更する雇用契約を締結した場合
        <br />
        ②本制度の契約対象外の施設等に配置換え（異動）した場合
        <br />
        ③雇用契約期間満了に伴う「雇用契約更新」を行う場合
        <br />
        <br />
        「退職」に該当する場合は、従業状況画面にある「退職（予定）日」に日付を入力してください。
        <br />
        なお、すでに届出済みの職員は、従業状況欄に氏名は表示されていません。
      </>
    ),
    guideText: "従業状況の更新を行ってください。",
  },
];

export { stepper, InfoManual, itemList };
